import * as types from '../../../constants/actionTypes';
import { prepareOccupations } from '../../../utils/occupation-utils';

const initialState = {
    images: [],
    prevImagesState: null,
    errorMessage: null,
    loading: false,
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        /* Upload */
        case types.UPLOAD_IMAGE:
            return {
                ...state,
                loading: true,
            };
        case types.UPLOAD_IMAGE_SUCCESS:
            return {
                ...state,
                images: [...state.images, action.result],
                loading: false,
            };
        case types.UPLOAD_IMAGE_FAIL:
            return {
                ...state,
                loading: false,
            };

        /* Remove */
        case types.REMOVE_IMAGE:
            return {
                ...state,
                loading: true,
            };
        case types.REMOVE_IMAGE_SUCCESS:
            return {
                ...state,
                images: state.images.filter(
                    (item) => item.id !== action.imageId
                ),
                loading: false,
            };
        case types.REMOVE_IMAGE_FAIL:
            return {
                ...state,
                loading: false,
            };

        /* Update */
        case types.UPDATE_IMAGE:
            return {
                ...state,
                errorMessage: null,
                loading: true,
            };
        case types.UPDATE_IMAGE_SUCCESS: {
            return {
                ...state,
                images: state.images.map((image) =>
                    image.id === action.imageId
                        ? {
                              ...image,
                              ...action.result,
                              occupations: prepareOccupations(
                                  action.result.occupations
                              ),
                          }
                        : image
                ),
                loading: false,
            };
        }
        case types.UPDATE_IMAGE_FAIL:
            return {
                ...state,
                errorMessage: action.error.message || action.error.text,
                loading: false,
            };

        /* Reorder */
        case types.REORDER_IMAGE:
            // temporary store old state, in case somethings goes wrong
            state.prevImagesState = state.images;

            return {
                ...state,
                // swap the images array
                images: action.reorderList.map((item) =>
                    state.images.find((image) => image.id === item)
                ),
                loading: true,
            };
        case types.REORDER_IMAGE_SUCCESS:
            return {
                ...state,
                prevImagesState: null,
                loading: false,
            };
        case types.REORDER_IMAGE_FAIL:
            return {
                ...state,
                // restore to old state
                images: state.prevImagesState,
                loading: false,
            };

        /* All other type */
        default:
            return state;
    }
}
